import { useEffect } from "react";
import { Link, Route, Routes } from "react-router-dom";
import { CAMap } from "../ca/map/CAMap";
import { Search } from "../ca/search/Search";
import { CaMapProvider, useAccount, useCaMapProvider } from "../ca/state";
import { config } from "../ca/state/config";
import logo from "../img/logo/ka_logo_long.png?url";
import { KaFacet } from "./KaFacet";
import { Report } from "./Report";

export const defaultSearch =
  "reference[range][building_area]=700:&reference[refinementList][land_cover][0]=Weiland&reference[refinementList][land_cover][1]=Landbouw&reference[refinementList][built_up_area][0]=Buiten bebouwde kom";
const Header = () => {
  useEffect(() => {
    config.logo = logo;
  }, []);
  return (
    <header
      className="fixed w-full h-14 flex items-center justify-between bg-white text-dark font-semibold z-50 border-b border-gray"
      style={{ zIndex: 100 }}
    >
      <div className="flex shrink justify-start ml-5">
        <Link to="/">
          <div>
            <span className="sr-only">{config.site.title}</span>
            <img className={`h-12 w-auto`} src={config.logo} alt={config.site.title} />
          </div>
        </Link>
        <nav className="relative flex mx-auto text-dark font-semibold space-x-10">
          <Link
            to={`/search?${defaultSearch}`}
            className="inline-flex pt-3 pl-3 hover:text-yellow/90 relative"
          >
            <span>Filter</span>
          </Link>
        </nav>
      </div>
    </header>
  );
};

const App = () => {
  const m = useCaMapProvider();
  const refresh = useAccount(({ refresh }) => refresh);
  useEffect(() => {
    refresh();
  }, [refresh]);
  return (
    <CaMapProvider value={m}>
      <div className="font-sans antialiased min-h-screen flex flex-col text-black">
        <title>{config.site.title}</title>
        <Header />
        <CAMap className="ca-cadamap top-14 fixed w-full" />
        <Routes>
          <Route
            path="/"
            element={
              <Search className="fixed z-10 flex flex-col top-16 left-6 w-3/4 sm:w-[29rem]" />
            }
          />
          <Route path="/search" element={<KaFacet />} />
          <Route path="/location/*" element={<Report />} />
        </Routes>
      </div>
    </CaMapProvider>
  );
};
export default App;
